// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__gQgly","inline":"ThemeToggle_inline__Bsq6g","landing":"ThemeToggle_landing__4tJny"};